"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUnableToAct = exports.isStunned = exports.isDeadish = exports.makeDeadish = exports.networkHurtEnergy = exports.hurtEnergy = exports.maxEnergy = exports.networkHurt = exports.hurt = exports.say = exports.getItemSafe = exports.getFirstDroppableItem = exports.isHolding = exports.removeDead = exports.updateTickAll = exports.updateAll = exports.killAll_exceptHeroesAndPets = exports.killAll = exports.kill = exports.moveToXY = exports.moveToIIJ = exports.moveToIJ = exports.setTile = exports.create = exports.createMonster = exports.getAtIIJ = exports.countAtIJ = exports.getAtIJ = exports.findByIdSafe = exports.findById = exports.getAllFiltered = exports.getAll = exports.EVoyageCrewType = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageMessageCrewCarry_sidecar_1 = require("@voyage/multi/voyageMessageCrewCarry-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var voyageMessageCrewHurt_sidecar_1 = require("@voyage/multi/voyageMessageCrewHurt-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_enemy_sidecar_1 = require("@voyage/crew/diveCrew_enemy-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageCarryable_sidecar_1 = require("@voyage/entities/voyageCarryable-sidecar");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var voyageMessageCrewHurtEnergy_sidecar_1 = require("@voyage/multi/voyageMessageCrewHurtEnergy-sidecar");
var voyageMessageMoney_sidecar_1 = require("@voyage/multi/voyageMessageMoney-sidecar");
var voyageFakeInfo_sidecar_1 = require("@voyage/text/voyageFakeInfo-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageParticles_sidecar_1 = require("@voyage/particles/voyageParticles-sidecar");
var diveAiState_sidecar_1 = require("@dive/ai/diveAiState-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
var diveParticles_sidecar_1 = require("@dive/effects/diveParticles-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveObjectsData_1 = require("@dive/entities/diveObjectsData");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var diveFloatingText_sidecar_1 = require("@dive/text/diveFloatingText-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var randoInstanced_sidecar_1 = require("@dive/to-engine/randoInstanced-sidecar");
var arrayUtils_sidecar_1 = require("@engine/arrayUtils-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var diveCrew_attackable_sidecar_1 = require("./diveCrew_attackable-sidecar");
var diveCrew_hero_data_1 = require("./diveCrew_hero_data");
var diveCrew_hero_misc_sidecar_1 = require("./diveCrew_hero_misc-sidecar");
var diveCrew_movable_sidecar_1 = require("./diveCrew_movable-sidecar");
var diveCrew_pet_sidecar_1 = require("./diveCrew_pet-sidecar");
var EVoyageCrewType;
(function (EVoyageCrewType) {
    EVoyageCrewType[EVoyageCrewType["Default"] = -1] = "Default";
    EVoyageCrewType[EVoyageCrewType["Null"] = 0] = "Null";
    EVoyageCrewType[EVoyageCrewType["Hero"] = 1] = "Hero";
    EVoyageCrewType[EVoyageCrewType["Fire"] = 2] = "Fire";
    EVoyageCrewType[EVoyageCrewType["Enemy"] = 3] = "Enemy";
    EVoyageCrewType[EVoyageCrewType["HullBreach"] = 4] = "HullBreach";
    EVoyageCrewType[EVoyageCrewType["Pet"] = 5] = "Pet";
})(EVoyageCrewType = exports.EVoyageCrewType || (exports.EVoyageCrewType = {}));
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function getAllFiltered(f) {
    return objs.filter(f);
}
exports.getAllFiltered = getAllFiltered;
function findById(id) {
    return entitiesUtils_sidecar_1.entitiesUtils.findById(id, objs);
}
exports.findById = findById;
function findByIdSafe(id) {
    return entitiesUtils_sidecar_1.entitiesUtils.findByIdSafe(id, objs);
}
exports.findByIdSafe = findByIdSafe;
function getAtIJ(i, j, filter) {
    for (var idx = 0; idx < objs.length; idx++) {
        var c = objs[idx];
        if (c.isDownStairs) {
            continue;
        }
        if (c.isDead || c.isDying) {
            continue;
        }
        if (i === c.i && j === c.j) {
            if (!filter || filter(c)) {
                return c;
            }
        }
    }
    return null;
}
exports.getAtIJ = getAtIJ;
function countAtIJ(i, j, filter) {
    var count = 0;
    for (var idx = 0; idx < objs.length; idx++) {
        var c = objs[idx];
        if (c.isDownStairs) {
            continue;
        }
        if (c.isDead || c.isDying || c.hitpoints <= 0) {
            continue;
        }
        if (i === c.i && j === c.j) {
            if (!filter || filter(c)) {
                count++;
                //return c
            }
        }
    }
    return count;
}
exports.countAtIJ = countAtIJ;
function getAtIIJ(iij, filter) {
    return getAtIJ(iij.i, iij.j, filter);
}
exports.getAtIIJ = getAtIIJ;
function createMonster(id, enemyType) {
    var obj = create(EVoyageCrewType.Enemy, diveCrew_hero_data_1.EDiveHeroSubtype.None, enemyType, id);
    return obj;
}
exports.createMonster = createMonster;
function create(type, heroType, enemyType, team, id) {
    if (id === void 0) { id = 0; }
    id = diveSimulationManager_sidecar_1.diveSimulationManager.synced_createId(id);
    var isHost = voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost();
    var scale = 1;
    var frame = sprites_sidecar_1.sprites.voyTileCrew[0];
    if (type === EVoyageCrewType.Fire) {
        frame = sprites_sidecar_1.sprites.voyTileFire[0];
        scale = 0.5;
    }
    if (type === EVoyageCrewType.HullBreach) {
        frame = sprites_sidecar_1.sprites.voyTileChecker2[0];
        scale = 0.5;
    }
    if (type === EVoyageCrewType.Pet) {
        frame = sprites_sidecar_1.sprites.voyAnimalPoodle[0];
        scale = 0.25;
    }
    if (type === EVoyageCrewType.Enemy) {
        frame = sprites_sidecar_1.sprites.voyInkMonsterAlien[0];
        scale = 0.25;
    }
    // let image = spritesUtil.createImage(voyageLayers.getLayers().shipCrew, frame)
    // image.scale = scale
    var info1 = '';
    var title = '';
    var rando = randoInstanced_sidecar_1.randoInstanced.createRando(id);
    var name = '' + id;
    // if (type === EVoyageCrewType.Fire) {
    //   name = 'Fire ' + name
    //   // image.tint = voyageColors.yellow
    // }
    // if (type === EVoyageCrewType.HullBreach) {
    //   name = 'Hull Breach ' + name
    //   // image.tint = voyageColors.damage
    // }
    if (type === EVoyageCrewType.Hero) {
        // TODO: generate this using the sync'd rando
        // name = 'Crew ' + name
        name = voyageFakeInfo_sidecar_1.voyageFakeInfo.genFakeName_nonDeterministic();
        if (isHost) {
            // info1 = voyageFakeInfo.genFakeLike(rando)
            //title = voyageFakeInfo.genFakeTitle(rando)
        }
        else {
            // name = 'Fetching bio...'
        }
    }
    if (type === EVoyageCrewType.Enemy) {
        name = 'Alien ' + name;
        // image.tint = voyageColors.green
    }
    var obj = {
        id: id,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        rando: rando,
        //image,
        team: team,
        type: type,
        heroType: heroType,
        enemyType: enemyType,
        x: 0,
        y: 0,
        lerp_start_x: 0,
        lerp_start_y: 0,
        lerp_target_x: 0,
        lerp_target_y: 0,
        lerp_isLerping: false,
        lerp_time: 0,
        lerp_timeMax: 0,
        i: -1,
        j: -1,
        name: name,
        info1: info1,
        title: title,
        pathResult: null,
        pathIdx: 0,
        moveTimer: 0,
        footstepTimer: 0,
        hitpoints: 100,
        fireState: null,
        heroState: null,
        breachState: null,
        enemyState: null,
        animalState: null,
        weaponState: null,
        // carryable: null,
        items: [],
        requestedInfo: isHost,
        // Todo: move to crew?
        energy: 0,
        energyTimer: 0,
        sleepyEffectTimer: 0,
        passedOutTimer: 0,
        isPassedOut: false,
        tile: null,
        isFlipped: false,
        weaponSlot: null,
        itemSlot1: null,
        lootSlot1: null,
        preferredTarget: null,
        ai: diveAiState_sidecar_1.diveAiState.create(),
        isUpStairs: false,
        isDownStairs: false,
        stairsFadeTimeSeconds: 0,
        isAwake: false,
        ticksAwake: 0,
        stunLeft: 0,
    };
    objs.push(obj);
    // if (type === EVoyageCrewType.Fire) {
    //   obj.fireState = voyageCrew_fire.create()
    //   obj.hitpoints = 1
    // }
    // if (type === EVoyageCrewType.HullBreach) {
    //   obj.breachState = voyageCrew_hullBreach.create()
    //   obj.hitpoints = 10
    // }
    if (type === EVoyageCrewType.Hero) {
        // TODO: move this to hero type
        // TODO: base on weapon
        obj.hitpoints = 100;
        obj.heroState = diveCrew_hero_sidecar_1.diveCrew_hero.create(heroType);
        diveCrew_hero_misc_sidecar_1.diveCrew_hero_misc.changeHeroClass(obj, heroType, false, true);
        // obj.carryable = voyageCarryable.create(EVoyageCarryableType.Coffee)
    }
    if (type === EVoyageCrewType.Enemy) {
        assert_sidecar_1.assert.notEmptyString(enemyType, 'enemy type is empty');
        obj.enemyState = diveCrew_enemy_sidecar_1.diveCrew_enemy.create(enemyType);
        obj.weaponState = diveCrew_attackable_sidecar_1.diveCrew_attackable.createWeaponStateForEnemy(enemyType);
        obj.hitpoints = obj.enemyState.data.maxHitpoints;
        // console.log(
        //   'set hitpoints of monster',
        //   obj.hitpoints,
        //   obj.enemyState.data.maxHitpoints,
        //   obj.enemyState.data.name,
        // )
        obj.title = 'Enemy Scum';
        // Copy initial ai
        obj.ai = diveAiState_sidecar_1.diveAiState.clone(obj.enemyState.data.initialAi);
    }
    if (type === EVoyageCrewType.Pet) {
        // TODO: pet should have pet ai
        obj.animalState = diveCrew_pet_sidecar_1.diveCrew_pet.create();
        obj.hitpoints = 100;
        obj.title = 'Indie';
    }
    return obj;
}
exports.create = create;
function setTile(obj, tile) {
    if (tile === obj.tile) {
        // Allready set
        return;
    }
    // Remove from current
    if (obj.tile) {
        arrayUtils_sidecar_1.arrayUtils.remove(obj.tile.crew, obj);
    }
    // Add to new
    obj.tile = tile;
    if (obj.tile) {
        arrayUtils_sidecar_1.arrayUtils.addIfNew(obj.tile.crew, obj);
        obj.i = obj.tile.i;
        obj.j = obj.tile.j;
        obj.isDownStairs = false;
        obj.isUpStairs = false;
    }
    if (!tile) {
        obj.i = -1;
        obj.j = -1;
    }
}
exports.setTile = setTile;
function moveToIJ(obj, i, j) {
    var t = diveTilemap_sidecar_1.diveTilemap.getSafe(i, j);
    setTile(obj, t); // Also sets i and j
    if (t) {
        moveToXY(obj, t.x, t.y);
        // if (obj.type === EVoyageCrewType.Fire) {
        //   let tCur = voyageTilemap.getSafeIJ(obj)
        //   if (tCur && tCur.fire === obj) {
        //     tCur.fire = null
        //   }
        //   t.fire = obj
        // }
        // if (obj.type === EVoyageCrewType.HullBreach) {
        //   let tCur = voyageTilemap.getSafeIJ(obj)
        //   if (tCur && tCur.breach === obj) {
        //     tCur.breach = null
        //   }
        //   t.breach = obj
        // }
        // if (obj.type === EVoyageCrewType.Hero) {
        //   // if (t.system) {
        //   //   if (t.system.data.onEnter) {
        //   //     t.system.data.onEnter(obj, voyageCrew_movable.isFinalMove(obj))
        //   //   }
        //   // }
        // }
    }
}
exports.moveToIJ = moveToIJ;
function moveToIIJ(obj, iij) {
    moveToIJ(obj, iij.i, iij.j);
}
exports.moveToIIJ = moveToIIJ;
function moveToXY(obj, x, y) {
    var e = 0.5;
    diveCrew_movable_sidecar_1.diveCrew_movable.faceXY(obj, x, y);
    obj.x = x;
    obj.y = y;
    // obj.image.x = x
    // obj.image.y = y
    // if (obj.crewState && obj.crewState.body) {
    //   voyageBodies.moveToXY(obj.crewState.body, x, y, obj.isFlipped)
    // }
    // if (obj.crewState && obj.crewState.progressBar) {
    //   voyageProgressBars.moveTo(obj.crewState.progressBar, obj.x, obj.y + 8)
    // }
    // if (obj.items.length > 0) {
    //   l.forEach(obj.items, (c) => {
    //     let flipMult = obj.isFlipped ? -1 : 1
    //     voyageCarryable.moveToXY(
    //       c,
    //       x + c.data.carryOx * flipMult,
    //       y + c.data.carryOy,
    //       obj.isFlipped,
    //     )
    //   })
    // }
    // if (obj.type === EVoyageCrewType.Pet) {
    //   obj.image.flipX = obj.isFlipped
    // }
}
exports.moveToXY = moveToXY;
function kill(obj) {
    obj.isDead = true;
    // console.log('KILL crew', obj.id, obj.name, obj.enemyType, obj.heroType)
    setTile(obj, null);
    if (obj.type === EVoyageCrewType.Fire) {
        var tCur = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
        if (tCur && tCur.fire === obj) {
            tCur.fire = null;
        }
    }
    if (obj.type === EVoyageCrewType.HullBreach) {
        var tCur = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
        if (tCur && tCur.breach === obj) {
            tCur.breach = null;
        }
    }
}
exports.kill = kill;
function killAll(reason) {
    console.log('KILL all crew', reason);
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function killAll_exceptHeroesAndPets() {
    console.log('KILL all except heroes and pets');
    imports_1.l.forEach(objs, function (c) {
        if (c.type === EVoyageCrewType.Hero) {
            return;
        }
        if (c.type === EVoyageCrewType.Pet) {
            return;
        }
        kill(c);
    });
    removeDead();
}
exports.killAll_exceptHeroesAndPets = killAll_exceptHeroesAndPets;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
}
exports.updateAll = updateAll;
function updateTickAll() {
    imports_1.l.forEach(objs, function (c) {
        updateTick(c);
        //say(c, '' + c.id)
    });
    removeDead();
}
exports.updateTickAll = updateTickAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        // c.image.destroy()
        setTile(c, null);
        // console.log('removing dead crew', c, c.heroType)
        // if (c.crewState && c.crewState.body) {
        //   voyageBodies.kill(c.crewState.body)
        // }
        if (c.items.length > 0) {
            imports_1.l.forEach(c.items, function (d) {
                voyageCarryable_sidecar_1.voyageCarryable.kill(d);
            });
        }
    });
}
exports.removeDead = removeDead;
function isHolding(obj, type) {
    // if (obj.items.length === 0) {
    //   return false
    // }
    for (var i = 0; i < obj.items.length; i++) {
        if (obj.items[i].type === type) {
            return true;
        }
    }
    return false;
}
exports.isHolding = isHolding;
function getFirstDroppableItem(obj) {
    for (var i = 0; i < obj.items.length; i++) {
        if (obj.items[i].type !== voyageCarryableData_1.EVoyageCarryableType.Coffee) {
            return obj.items[i];
        }
    }
    return null;
}
exports.getFirstDroppableItem = getFirstDroppableItem;
function getItemSafe(obj, type) {
    for (var i = 0; i < obj.items.length; i++) {
        if (obj.items[i].type === type) {
            return obj.items[i];
        }
    }
    return null;
}
exports.getItemSafe = getItemSafe;
function updateTick(obj) {
    if (obj.isDead || obj.isDying) {
        if (obj.isDying) {
            kill(obj);
        }
        return;
    }
    if (obj.stunLeft > 0) {
        obj.stunLeft--;
    }
    if (obj.type === EVoyageCrewType.Hero) {
        diveCrew_hero_sidecar_1.diveCrew_hero.updateTick(obj);
    }
    if (obj.type === EVoyageCrewType.Enemy) {
        diveCrew_enemy_sidecar_1.diveCrew_enemy.updateTick(obj);
    }
    if (obj.type === EVoyageCrewType.Pet) {
        diveCrew_pet_sidecar_1.diveCrew_pet.updateTick(obj);
    }
}
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    // if (obj.type === EVoyageCrewType.Fire) {
    //   voyageCrew_fire.update(obj)
    // }
    // if (obj.type === EVoyageCrewType.HullBreach) {
    //   voyageCrew_hullBreach.update(obj)
    // }
    if (obj.isDead || obj.isDying) {
        return;
    }
    // if (obj.isDying) {
    //   kill(obj)
    // }
    if (diveCrew_sidecar_1.diveCrew.isStunned(obj)) {
        if (diveSimulationManager_sidecar_1.diveSimulationManager.getIsTickFrame())
            diveParticles_sidecar_1.diveParticles.createMultiple('stars', obj.x, obj.y, 1, diveColors_1.diveColors.pureWhite);
    }
    // TODO: restore movable and fireable
    if (obj.type === EVoyageCrewType.Hero) {
        // diveCrew_attackable.update(obj)
        diveCrew_hero_sidecar_1.diveCrew_hero.update(obj);
    }
    if (obj.type === EVoyageCrewType.Enemy) {
        // diveCrew_attackable.update(obj)
        diveCrew_enemy_sidecar_1.diveCrew_enemy.update(obj);
    }
    if (obj.type === EVoyageCrewType.Pet) {
        diveCrew_pet_sidecar_1.diveCrew_pet.update(obj);
    }
}
function say(obj, text) {
    if (!text) {
        return;
    }
    if (obj.isPassedOut) {
        return;
    }
    // TODO: fix
    // voyageFloatingText.create(obj.x, obj.y - 16, text)
    diveFloatingText_sidecar_1.diveFloatingText.create(obj.x, obj.y - 16, text);
}
exports.say = say;
function hurt(obj, damage, reason, hurtByCrewId) {
    // TODO: kill, etc.
    var _a, _b;
    if (obj.hitpoints > 0) {
        obj.hitpoints -= damage;
        if (obj.hitpoints <= 0) {
            obj.hitpoints = 0;
            // Drop any objects
            console.log('killed, dropping objects');
            if (obj.weaponSlot) {
                diveObjects_sidecar_1.diveObjects.do_drop(obj, obj.weaponSlot, diveObjectsData_1.EDiveEquipSlot.Weapon, false, true);
            }
            if (obj.lootSlot1) {
                diveObjects_sidecar_1.diveObjects.do_drop(obj, obj.lootSlot1, diveObjectsData_1.EDiveEquipSlot.Loot, false, true);
            }
            if (obj.itemSlot1) {
                diveObjects_sidecar_1.diveObjects.do_drop(obj, obj.itemSlot1, diveObjectsData_1.EDiveEquipSlot.Item, false, true);
            }
        }
        var maxHp = 100;
        if (obj.enemyState) {
            maxHp = obj.enemyState.data.maxHitpoints;
        }
        if (obj.hitpoints > maxHp) {
            obj.hitpoints = maxHp;
        }
        console.log('hurt', ((_a = obj.enemyState) === null || _a === void 0 ? void 0 : _a.data.name) || obj.name, damage, obj.hitpoints);
    }
    else {
        console.log('hurt (already at 0 hp)', ((_b = obj.enemyState) === null || _b === void 0 ? void 0 : _b.data.name) || obj.name, damage, obj.hitpoints);
    }
    // if (voyageWebsockets.getIsHost()) {
    //   voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
    //     crewId: obj.id,
    //     byCrewId: hurtByCrewId,
    //     newHitpoints: obj.hitpoints - damage,
    //     type: reason,
    //   })
    //   // obj.hitpoints -= damage
    //   // if (obj.hitpoints <= 0) {
    //   //   makeDeadish(obj, reason)
    //   // }
    // }
}
exports.hurt = hurt;
function networkHurt(msg) {
    var obj = findById(msg.crewId);
    assert_sidecar_1.assert.notNil(obj);
    if (obj.type === EVoyageCrewType.Hero || obj.type === EVoyageCrewType.Enemy) {
        if (msg.newHitpoints > obj.hitpoints) {
            // Heal
            var healer = findByIdSafe(msg.byCrewId);
            if (healer && healer.heroState) {
                healer.heroState.statHeals += msg.newHitpoints - obj.hitpoints;
            }
        }
        else {
            // Damage
            var damager = findByIdSafe(msg.byCrewId);
            if (damager && damager.heroState) {
                damager.heroState.statDamageGiven += -(msg.newHitpoints - obj.hitpoints);
            }
        }
    }
    obj.hitpoints = msg.newHitpoints;
    if (obj.hitpoints <= 0 && !obj.isDying && !obj.isDead) {
        if (msg.type === voyageMessageCrewHurt_1.EVoyageCrewDamageType.Teleport) {
            voyageParticles_sidecar_1.voyageParticles.createMultiple('teleport', obj.x, obj.y + 16, 18);
            diveCrew_sidecar_1.diveCrew.kill(obj);
        }
        else {
            if (obj.type === EVoyageCrewType.Enemy) {
                if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                    voyageMessageMoney_sidecar_1.voyageMessageMoney.sendMessageAndImmediatelyExecute({
                        money: voyageGameStatus_sidecar_1.voyageGameStatus.get().money + 25,
                    });
                }
            }
            makeDeadish(obj, msg.type, msg.byCrewId);
        }
    }
}
exports.networkHurt = networkHurt;
exports.maxEnergy = 500;
function hurtEnergy(obj, energyDamage) {
    if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        var newEnergyPoints = obj.energy - energyDamage;
        newEnergyPoints = mathUtils_sidecar_1.mathUtils.clamp(newEnergyPoints, 0, exports.maxEnergy);
        voyageMessageCrewHurtEnergy_sidecar_1.voyageMessageCrewHurtEnergy.sendMessageAndImmediatelyExecute({
            crewId: obj.id,
            newEnergyPoints: newEnergyPoints,
        });
    }
}
exports.hurtEnergy = hurtEnergy;
function networkHurtEnergy(msg) {
    var obj = findById(msg.crewId);
    if (!obj) {
        websockets_sidecar_1.websockets.reportBadCommand2(msg, 'crew is null');
        return;
    }
    obj.energy = msg.newEnergyPoints;
    obj.passedOutTimer = 0;
    obj.isPassedOut = obj.energy === 0;
}
exports.networkHurtEnergy = networkHurtEnergy;
function makeDeadish(obj, damageType, byCrewId) {
    if (!obj.isDying) {
        if (obj.type === EVoyageCrewType.Enemy) {
            voyageSounds_sidecar_1.voyageSounds.playDeathAlien();
            voyageGameStatus_sidecar_1.voyageGameStatus.addAlienDead();
            if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                // Create a corpse here
                voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendCreateMessageAndImmediatelyExecute({
                    type: voyageCarryableData_1.EVoyageCarryableType.AlienCorpse,
                    i: obj.i,
                    j: obj.j,
                });
            }
            diveCrew_sidecar_1.diveCrew.moveToIIJ(obj, { i: 0, j: 0 });
        }
        if (obj.type === EVoyageCrewType.Hero) {
            voyageSounds_sidecar_1.voyageSounds.playDeathCrewmember();
            var reason = voyageMessageCrewHurt_sidecar_1.voyageMessageCrewHurt.getDamageReason(damageType);
            voyageGameStatus_sidecar_1.voyageGameStatus.addDeadLog(obj.name + ' (' + obj.title + ') ' + reason);
            if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                // Create a corpse here
                voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendCreateMessageAndImmediatelyExecute({
                    type: voyageCarryableData_1.EVoyageCarryableType.CrewCorpse,
                    i: obj.i,
                    j: obj.j,
                    crewId: obj.id,
                });
            }
            // diveCrew.moveToIJ(obj, { i: 0, j: 0 })
        }
        // obj.image.tint = voyageColors.g2
        obj.isDying = true;
        var killer = diveCrew_sidecar_1.diveCrew.findByIdSafe(byCrewId);
        if (killer && killer.heroState) {
            if (obj.type === EVoyageCrewType.Enemy ||
                obj.type === EVoyageCrewType.Hero) {
                killer.heroState.statKills++;
            }
            if (obj.type === EVoyageCrewType.Fire) {
                killer.heroState.statFiresFought++;
            }
            if (obj.type === EVoyageCrewType.HullBreach) {
                killer.heroState.statRepairs++;
            }
        }
    }
}
exports.makeDeadish = makeDeadish;
function isDeadish(obj) {
    return obj.isDead || obj.isDying || obj.hitpoints <= 0;
}
exports.isDeadish = isDeadish;
function isStunned(obj) {
    return obj.stunLeft > 0;
}
exports.isStunned = isStunned;
function isUnableToAct(obj) {
    return isStunned(obj) || isDeadish(obj);
}
exports.isUnableToAct = isUnableToAct;
